import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
    keyword = '';
    handleSearch() {
        this.$emit('handleSearch', this.keyword);
        console.log('search');
    }
};
default_1 = __decorate([
    Component({
        name: 'PhotoTableHeader',
        i18n: {
            messages: {
                'en-us': {
                    accountList: 'Account List',
                    exportCsv: 'Export Excel',
                    create: 'Create',
                    search: 'Search',
                    pic: 'Picture Names'
                },
                zh: {
                    accountList: '账户列表',
                    exportCsv: '导出Csv',
                    create: '创建账户',
                    search: '搜索',
                    pic: '图片名称'
                },
            },
        },
    })
], default_1);
export default default_1;
